(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-list-tabs"] && !Shopify.designMode) return;
  try {
    class ProductListTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const button = event.target.closest('button[data-collection-handle]');
      if (!button || !this.contains(button)) return;

      const handle = button.getAttribute('data-collection-handle');

      this.querySelectorAll('button[data-collection-handle]').forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab === button));
      });

      this.filterProducts(handle);
    };

    filterProducts(handle) {
      const root = this.closest('.section-resource-list');
      if (!root) return;

      const items = root.querySelectorAll('.resource-list__item[data-collection-handle]');

      items.forEach((item) => {
        const matches = handle === 'all' || item.dataset.collectionHandle === handle;
        const slide = item.closest('slideshow-slide');
        const target = slide || item;
        target.hidden = !matches;
      });

      const slideshow = root.querySelector('slideshow-component');
      if (slideshow) {
        // Re-triggers the slideshow's own hidden-slide handling (see attributeChangedCallback).
        slideshow.setAttribute('initial-slide', '0');
      }
    }
  }

  if (!customElements.get('product-list-tabs')) {
    customElements.define('product-list-tabs', ProductListTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
